// src/components/CartSidebar/index.jsx
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { formatarPrecoUnitario } from '../../utils/precoUnitario';
import api from '../../api';
import './index.scss';

export default function CartSidebar({ open, onClose }) {
    const navigate = useNavigate();
    const { items, updateQuantity, clearCart, removeItem } = useCart();
    const [limiteFreteGratis, setLimiteFreteGratis] = useState(200);

    useEffect(() => {
        const carregarConfigFrete = async () => {
            try {
                const response = await api.get('/frete/config');
                if (response.data?.success) {
                    setLimiteFreteGratis(Number(response.data.limiteFreteGratis || 200));
                }
            } catch (_) {
                setLimiteFreteGratis(200);
            }
        };

        carregarConfigFrete();
    }, []);

    const total = items.reduce((sum, i) => sum + ((Number(i.preco) || 0) * i.quantidade), 0);
    const freteGratis = total >= limiteFreteGratis;
    const faltaFrete = Math.max(limiteFreteGratis - total, 0);
    const progressoFrete = Math.min((total / Math.max(limiteFreteGratis, 1)) * 100, 100);

    const handleCheckout = () => {
        onClose();
        navigate('/checkout');
    };

    return (
        <>
            <div
                className={`cart-backdrop ${open ? 'open' : ''}`}
                onClick={onClose}
            />

            <aside className={`cart-sidebar ${open ? 'open' : ''}`}>
                <header>
                    <h3>Seu Carrinho</h3>
                    <button onClick={onClose}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.16667 5.16667L7.66667 7.66667M7.66667 7.66667L10.1667 10.1667M7.66667 7.66667L5.16667 10.1667M7.66667 7.66667L10.1667 5.16667M1 11.6667V3.66667C1 2.73333 1 2.26667 1.18167 1.91C1.34167 1.59583 1.59583 1.34167 1.91 1.18167C2.26667 1 2.73333 1 3.66667 1H11.6667C12.6 1 13.0667 1 13.4233 1.18167C13.7369 1.34145 13.9919 1.59641 14.1517 1.91C14.3333 2.26667 14.3333 2.73333 14.3333 3.66667V11.6667C14.3333 12.6 14.3333 13.0667 14.1517 13.4233C13.9919 13.7369 13.7369 13.9919 13.4233 14.1517C13.0667 14.3333 12.6017 14.3333 11.67 14.3333H3.66417C2.7325 14.3333 2.26583 14.3333 1.91 14.1517C1.59641 13.9919 1.34145 13.7369 1.18167 13.4233C1 13.0667 1 12.6 1 11.6667Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                </header>
                <div className="cart-content">
                    {items.length === 0
                        ? <p>Seu carrinho está vazio.</p>
                        : items.map(i => {
                            const atributos = [];
                            if (i.cor) atributos.push(i.cor);
                            if (i.tamanho) atributos.push(i.tamanho);
                            if (i.tipo) atributos.push(i.tipo);
                            if (i.material) atributos.push(i.material);
                            const descricaoAtributos = atributos.join(' / ');
                            const produtoLink = `/produto/${i.id_produto}${i.id ? `?variacao=${i.id}` : ''}`;

                            return (
                            <div key={i.id} className="cart-item">
                                <Link to={produtoLink} onClick={onClose}>
                                    <img src={i.imagem_principal} alt={i.nome} />
                                </Link>
                                <div className="item-info">
                                    <Link to={produtoLink} onClick={onClose} className="item-title-link">
                                        <h4>{i.nome}</h4>
                                    </Link>
                                    {descricaoAtributos && <p className="item-atributos">{descricaoAtributos}</p>}
                                    <div className="preco-info">
                                        <p className="preco-pacote">R$ {(Number(i.preco) || 0).toFixed(2)}{i.unidades_por_pacote > 1 && (
                                            <span className="preco-unitario-lado"> | Preço/Unit. {formatarPrecoUnitario(i.preco, i.unidades_por_pacote)}</span>
                                        )}</p>
                                    </div>
                                    <p className="item-subtotal">
                                        Qtd: {i.quantidade} {i.unidades_por_pacote ? `| ${i.unidades_por_pacote} Unit.` : ''} | Subtotal: R$ {(Number(i.preco) * i.quantidade).toFixed(2)}
                                    </p>

                                    <div className="qty-controls">
                                        <button className='bnt-mais' onClick={() => updateQuantity(i.id, + 1)}><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /></svg></button>
                                        <div className='input-qtd'>
                                            <input
                                                type="number"
                                                min="1"
                                                value={i.quantidade}
                                                onChange={(e) => {
                                                    const novaQuantidade = parseInt(e.target.value, 10);
                                                    if (!isNaN(novaQuantidade) && novaQuantidade > 0) {
                                                        updateQuantity(i.id, novaQuantidade - i.quantidade);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <button className='bnt-menos' onClick={() => updateQuantity(i.id, - 1)}><svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.38932 0H5.34766H11.3893C11.6656 0 11.9305 0.109747 12.1259 0.305097C12.3212 0.500447 12.431 0.765399 12.431 1.04167C12.431 1.31793 12.3212 1.58289 12.1259 1.77824C11.9305 1.97359 11.6656 2.08333 11.3893 2.08333H7.43099H1.38932C1.11306 2.08333 0.848104 1.97359 0.652753 1.77824C0.457403 1.58289 0.347656 1.31793 0.347656 1.04167C0.347656 0.765399 0.457403 0.500447 0.652753 0.305097C0.848104 0.109747 1.11306 0 1.38932 0Z" fill="white" /></svg></button>
                                        <button className="btn-remove" onClick={() => removeItem(i.id)}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            );
                        })
                    }
                </div>
                {items.length > 0 && (
                    <footer>
                        <div className="frete-progresso">
                            <div className="frete-info">
                                {freteGratis
                                    ? 'Frete gratis liberado'
                                    : `Faltam R$ ${faltaFrete.toFixed(2)} para frete gratis`}
                            </div>
                            <div className="frete-bar">
                                <div className="frete-bar-fill" style={{ width: `${progressoFrete}%` }} />
                            </div>
                        </div>
                        <div className="cart-total">
                            Sub-Total: R$ {total.toFixed(2)}
                        </div>
                        <button className="btn-clear-cart" onClick={clearCart}>
                            Limpar carrinho
                        </button>
                        <button
                            className="btn-checkout"
                            onClick={handleCheckout}
                        >
                            Finalizar Pedido
                        </button>
                    </footer>
                )}
            </aside>
        </>
    );
}